import Image from './Image'

export default class ImageCollection {
  raw = undefined
  /**
   * @type {Array<Image>}
   */
  images = []

  constructor (source = undefined) {
    this.raw = source
    if(source) {
      this.parseSource(source)
    }
  }

  parseSource (source) {
    this.images = source.map(i => {
      return new Image(i)
    })
  }

  /**
   *
   * @returns {Array<Image>}
   */
  all () {
    return this.images
  }

  /**
   *
   * @returns {Image|boolean}
   */
  first () {
    if(this.images.length < 1) {
      return false
    }

    return this.images[0]
  }

  /**
   *
   * @returns {string|boolean}
   */
  mainImage () {
    if(this.images.length < 1) {
      return false
    }

    return this.images[0].url
  }

}
